(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalController', MedalController);

    MedalController.$inject = ['Medal'];

    function MedalController(Medal) {

        var vm = this;

        vm.medals = [];

        loadAll();

        function loadAll() {
            Medal.query(function(result) {
                vm.medals = result;
                vm.searchQuery = null;
            });
        }
    }
})();
